export default {
    'diagram1': {
      'title': `<span>THE SALES FORCE EFFECTIVENESS PARADOX - PROBLEM</span>
        <br/><br/>
        Please drag and drop the elements of the problem definition into their correct positions in the framework`,
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header': '$Bn DISTRIBUTORS',
      'left-box': 'SALES FORCE',
      'right-box': 'SALES ENABLERS',
      'bottom-box-points': `
      <ul>
        <li>Strategic Partners</li>
        <li>National Accounts</li>
        <li style="position: relative; width: max-content;">Mid-size Accounts<br/>(80% of revenue here)</li>
      </ul>
      <ul>
        <li>Automatic Platforms</li>
        <li>Solution Sellling</li>
        <li>Challenger Training</li>
        <li>Large-scale ERP</li>
        <li>Replatforming programs</li>
      </ul>
      `,
      'situation-desc-short': 'DISTURBING EVENT',
      'situation-desc': 'Distributors make substantial investments in Sales<br/>Enablers to improve productivity of Sales Forces'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5b/diagram1/i18n/en.js